<div class="table-wrapper ts-scroll-top">
  <tses-alt-accessibility
    *ngIf="hasDisplayedResults"
    class="initial-departure-list"
    [altProperties]="accessibilityKeysService.getAltProperties(DasAccessibilityItem.DEPARTURE_LIST)"
  >
  </tses-alt-accessibility>

  <table
    mat-table
    [dataSource]="dataSource"
    matSort
    [matSortDisableClear]="true"
    (matSortChange)="onSortChange($event)"
  >
    <ng-container *ngFor="let displayedColumn of displayedColumns; let i = index" [matColumnDef]="displayedColumn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header [style.min-width]="getMinWidth(displayedColumn)">
        {{ getColumnHeader(displayedColumn) }}
      </th>
      <td mat-cell *matCellDef="let entry" class="link">
        <tses-alt-accessibility
          *ngIf="shouldAddAltAccessibilityKey(entry, i)"
          class="departure"
          [altProperties]="getAltProperties(entry)"
          (onSelect)="onEntryClick(entry)"
        ></tses-alt-accessibility>
        <div class="alt-row">
          <das-templatiser [template]="getColumnValue(displayedColumn, entry)"></das-templatiser>
        </div>
      </td>
    </ng-container>
    <tr class="columnNameTR" mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      *matRowDef="let row; let i = index; columns: displayedColumns"
      (click)="onEntryClick(row)"
      class="entry"
    ></tr>
  </table>

  <div *ngIf="noEntries()" class="no-departures">
    {{ emptyMessage }}
  </div>
</div>
<mat-paginator
  [length]="totalNumberOfResults"
  [pageSize]="pageSize"
  [pageSizeOptions]="[25, 50, 100]"
  [pageIndex]="pageIndex"
  [showFirstLastButtons]="true"
  (page)="onPaginationChange($event)"
></mat-paginator>
